export const CapacityPlausibilityCheck = {
    UNCHECKED: 'unchecked',
    CORRECT: 'correct',
    WRONG: 'wrong',
};
